/*!
 * MAC Industries - overhead table size section (theme build, sections/mac-table-size.liquid)
 * Based on Mark's standalone build (/workspace/mac/table-size-scroll). Theme changes:
 * catalogue synced from window.WELDING_CONFIGURATOR_DATA when present, "your table" step +
 * red outline when the customer picks a size, lazy start, re-measure when the page above
 * changes height, room for the theme's fixed mobile bars, configurator hook at the bottom.
 * Canvas 2D, true-scale top-down view. One constant px/mm scale per layout,
 * fitted so the largest size fills the view. Each size is rasterised once
 * (lazily, in idle time) into its own bitmap; per-frame work is only
 * 2 drawImage calls + a few vector overlays.
 * Public API: window.MacTableSize.setSize(l, w, {system:'16D'|'28D', animate:true})
 */
(function () {
  'use strict';
  var D = document, W0 = window, TAU = Math.PI * 2;

  /* ---------- Data (from the live configurator data file + spec drawings) ---------- */
  // [length, width, series offering it on 16D, series offering it on 28D]
  var CATALOG = [[520,520,["BASIC"],[]],[1000,600,["BASIC"],[]],[1200,600,["HOBBY"],[]],[1250,750,["MidiPRO","PRO 6","PRO 8","PRO 10"],["PRO 10"]],[1200,800,["HOBBY"],[]],[1000,1000,["MidiPRO","PRO 6","PRO 8","PRO 10"],["PRO 10"]],[1500,750,["MidiPRO","PRO 6","PRO 8","PRO 10"],["PRO 10"]],[1250,1000,["MidiPRO","PRO 6","PRO 8","PRO 10"],["PRO 10"]],[1750,750,["MidiPRO","PRO 6","PRO 8","PRO 10"],["PRO 10"]],[1400,1000,["ULTRA 10","ULTRA 15"],["ULTRA 10","ULTRA 15"]],[1500,1000,["MidiPRO","PRO 6","PRO 8","PRO 10"],["PRO 10"]],[1250,1250,["MidiPRO","PRO 6","PRO 8","PRO 10"],["PRO 10"]],[1800,900,["MidiPRO","PRO 6","PRO 8","PRO 10"],["PRO 10"]],[1750,1000,["MidiPRO","PRO 6","PRO 8","PRO 10"],["PRO 10"]],[1500,1250,["MidiPRO","PRO 6","PRO 8","PRO 10"],["PRO 10"]],[1400,1400,["ULTRA 10","ULTRA 15"],["ULTRA 10","ULTRA 15"]],[2000,1000,["MidiPRO","PRO 6","PRO 8","PRO 10"],["PRO 10"]],[1750,1250,["MidiPRO","PRO 6","PRO 8","PRO 10"],["PRO 10"]],[1500,1500,["MidiPRO","PRO 6","PRO 8","PRO 10"],["PRO 10"]],[2000,1250,["PRO 6","PRO 8","PRO 10"],["PRO 10"]],[2500,1000,["PRO 6","PRO 8","PRO 10"],["PRO 10"]],[1800,1400,["ULTRA 10","ULTRA 15"],["ULTRA 10","ULTRA 15"]],[1750,1500,["MidiPRO","PRO 6","PRO 8","PRO 10"],["PRO 10"]],[2200,1400,["ULTRA 10","ULTRA 15"],["ULTRA 10","ULTRA 15"]],[2500,1250,["PRO 6","PRO 8","PRO 10"],["PRO 10"]],[2800,1400,["ULTRA 10"],["ULTRA 10"]],[2800,1450,["ULTRA 15"],["ULTRA 15"]],[2900,1400,["PRO 6","PRO 8","PRO 10"],["PRO 10"]],[3000,1500,["ULTRA 10","ULTRA 15"],["ULTRA 10","ULTRA 15"]]];
  // Scroll story: real configurator sizes, smallest to largest, one per table family step
  var STORY = [[520, 520], [1000, 600], [1200, 800], [1500, 1000], [2000, 1000], [2500, 1250], [3000, 1500]];
  // Hole systems (MAC spec drawings: 16D = O16 on 50 mm grid, first hole 25 mm in;
  // 28D = O28, 100 mm pitch, staggered rows 50 mm apart, first hole 75 mm in)
  var SYSTEMS = {
    '16D': { key: '16D', hole: 16, pitch: 50, lattice: 50, edge: 25, stagger: false, label: '16D \u00b7 \u00d816 mm', grid: '50 \u00d7 50 mm' },
    '28D': { key: '28D', hole: 28, pitch: 100, lattice: 50, edge: 75, stagger: true, label: '28D \u00b7 \u00d828 mm', grid: '100 mm, staggered' }
  };

  var catSynced = false;
  function syncCatalog() { // keep sizes / 28D availability identical to the configurator data
    if (catSynced) return;
    var d = W0.WELDING_CONFIGURATOR_DATA;
    if (!d || !d.products || !d.products.length) return;
    var map = {}, out = [];
    d.products.forEach(function (p) {
      var sys = p.holeSystem === '28D' ? 3 : 2, name = String(p.name || p.title || p.id);
      (p.workingAreas || []).forEach(function (a) {
        var m = String(a).match(/(\d+)\s*x\s*(\d+)/i); if (!m) return;
        var k = m[1] + 'x' + m[2];
        if (!map[k]) { map[k] = [+m[1], +m[2], [], []]; out.push(map[k]); }
        if (map[k][sys].indexOf(name) < 0) map[k][sys].push(name);
      });
    });
    if (out.length) { CATALOG = out; catSynced = true; if (W0.MacTableSize) W0.MacTableSize.catalog = out; }
  }
  function findCat(l, w) {
    for (var i = 0; i < CATALOG.length; i++) {
      var c = CATALOG[i];
      if ((c[0] === l && c[1] === w) || (c[0] === w && c[1] === l)) return c;
    }
    return null;
  }
  function seriesText(list) {
    if (!list || !list.length) return '';
    var out = [], pro = [], ult = [];
    list.forEach(function (n) {
      if (/^PRO /.test(n)) pro.push(n.slice(4));
      else if (/^ULTRA /.test(n)) ult.push(n.slice(6));
      else out.push(n);
    });
    if (pro.length) out.push('PRO ' + pro.join('/'));
    if (ult.length) out.push('ULTRA ' + ult.join('/'));
    return out.join(' \u00b7 ');
  }

  /* ---------- Helpers ---------- */
  function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }
  function lerp(a, b, t) { return a + (b - a) * t; }
  function easeIO(t) { t = clamp(t, 0, 1); return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; }
  function fmt(n) { return String(Math.round(n)); }
  var RM_MQ = W0.matchMedia ? W0.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var RM = (RM_MQ && RM_MQ.matches) || /[?&]rm=1/.test(location.search);
  if (RM) D.documentElement.classList.add('mts-rm');
  var idle = W0.requestIdleCallback ? function (fn) { return W0.requestIdleCallback(fn, { timeout: 400 }); } : function (fn) { return setTimeout(function () { fn({ timeRemaining: function () { return 8; } }); }, 60); };
  var HFONT = '"M-Heading-Font","SF UI Text Condensed","Arial Narrow",sans-serif';
  var MONO = 'ui-monospace,SFMono-Regular,Menlo,Consolas,monospace';

  /* ---------- Hole layout ---------- */
  var layoutCache = {};
  function holeLayout(L, W, sysKey) {
    var k = L + 'x' + W + sysKey;
    if (layoutCache[k]) return layoutCache[k];
    var s = SYSTEMS[sysKey], step = s.lattice;
    var nx = Math.floor((L - 2 * s.edge) / step + 1e-6) + 1;
    var ny = Math.floor((W - 2 * s.edge) / step + 1e-6) + 1;
    var x0 = (L - (nx - 1) * step) / 2, y0 = (W - (ny - 1) * step) / 2;
    var pts = [];
    for (var j = 0; j < ny; j++) for (var i = 0; i < nx; i++) {
      if (s.stagger && ((i + j) & 1)) continue;
      pts.push(x0 + i * step, y0 + j * step);
    }
    return (layoutCache[k] = { pts: pts, count: pts.length / 2, x0: x0, y0: y0, nx: nx, ny: ny });
  }

  /* ---------- Shared textures ---------- */
  var noiseTile = null;
  function getNoise() {
    if (noiseTile) return noiseTile;
    var c = D.createElement('canvas'); c.width = c.height = 96;
    var g = c.getContext('2d'), im = g.createImageData(96, 96), d = im.data, seed = 1337;
    for (var i = 0; i < d.length; i += 4) {
      seed = (seed * 1664525 + 1013904223) >>> 0;
      var v = 96 + ((seed >>> 24) % 64);
      d[i] = d[i + 1] = d[i + 2] = v; d[i + 3] = 255;
    }
    g.putImageData(im, 0, 0);
    return (noiseTile = c);
  }

  /* ---------- Drop shadow: one tiny pre-blurred sprite drawn as a 9-slice ---------- */
  var SH = null, SHB = 34; // blur extent in css px
  function getShadow(dpr) {
    if (SH && SH.dpr === dpr) return SH;
    var b = Math.ceil(SHB * dpr), core = 8, size = 2 * b + core, c = D.createElement('canvas');
    c.width = c.height = size;
    var g = c.getContext('2d');
    g.shadowColor = 'rgba(0,0,0,1)'; g.shadowBlur = b * 0.55; g.shadowOffsetX = size; // draw the shape off-canvas, keep only its shadow
    g.fillRect(b - size, b, core, core);
    return (SH = { c: c, b: b, core: core, dpr: dpr });
  }
  function drawShadow(ctx, x, y, w, h, dpr, alpha) {
    var S = getShadow(dpr), b = S.b, k = S.core, c = S.c, e = b / dpr; // e = slice size in css px
    var X = [x - e, x, x + w, x + w + e], Y = [y - e, y, y + h, y + h + e], SX = [0, b, b + k, 2 * b + k];
    ctx.globalAlpha = alpha;
    for (var j = 0; j < 3; j++) for (var i = 0; i < 3; i++) {
      var dw = X[i + 1] - X[i], dh = Y[j + 1] - Y[j];
      if (dw > 0 && dh > 0) ctx.drawImage(c, SX[i], SX[j], SX[i + 1] - SX[i], SX[j + 1] - SX[j], X[i], Y[j], dw, dh);
    }
    ctx.globalAlpha = 1;
  }

  /* ---------- Table bitmap (drawn once per size/system/orientation/scale) ---------- */
  var PAD = 0; // bitmap = plate only; the drop shadow is a per-frame 9-slice sprite
  function renderTable(L, W, sysKey, s, rot, dpr) {
    var sys = SYSTEMS[sysKey];
    var pw = (rot ? W : L) * s, ph = (rot ? L : W) * s;
    var c = D.createElement('canvas');
    c.width = Math.ceil((pw + 2 * PAD) * dpr); c.height = Math.ceil((ph + 2 * PAD) * dpr);
    var g = c.getContext('2d');
    g.scale(dpr, dpr); g.translate(PAD, PAD);
    // steel base (screen space so the light is consistent in both orientations)
    var gr = g.createLinearGradient(0, 0, pw, ph);
    gr.addColorStop(0, '#7a8089'); gr.addColorStop(0.42, '#5d636b'); gr.addColorStop(0.7, '#686e76'); gr.addColorStop(1, '#4d5258');
    g.fillStyle = gr; g.fillRect(0, 0, pw, ph);
    // mill texture
    g.save();
    g.beginPath(); g.rect(0, 0, pw, ph); g.clip();
    g.globalAlpha = 0.16; g.globalCompositeOperation = 'overlay';
    g.setTransform(1, 0, 0, 1, 0, 0);
    g.fillStyle = g.createPattern(getNoise(), 'repeat'); g.fillRect(0, 0, c.width, c.height);
    g.restore();
    // soft light pool
    var rg = g.createRadialGradient(pw * 0.3, ph * 0.25, 0, pw * 0.3, ph * 0.25, Math.max(pw, ph) * 0.8);
    rg.addColorStop(0, 'rgba(255,255,255,0.10)'); rg.addColorStop(1, 'rgba(255,255,255,0)');
    g.fillStyle = rg; g.fillRect(0, 0, pw, ph);

    // table frame: x along length, y along width (y = W is the front edge)
    g.save();
    g.beginPath(); g.rect(0, 0, pw, ph); g.clip();
    if (rot) { g.translate(0, ph); g.rotate(-Math.PI / 2); }
    g.scale(s, s);
    var px = 1 / s; // one css px in mm
    // brushed streaks along the length (deterministic)
    var seed = (L * 7 + W * 13) >>> 0, n = Math.round(clamp(W / 12, 30, 160));
    for (var i = 0; i < n; i++) {
      seed = (seed * 1664525 + 1013904223) >>> 0; var y = (seed / 4294967296) * W;
      seed = (seed * 1664525 + 1013904223) >>> 0; var a = 0.018 + (seed / 4294967296) * 0.04;
      g.fillStyle = (i & 1) ? 'rgba(255,255,255,' + a + ')' : 'rgba(0,0,0,' + a + ')';
      g.fillRect(0, y, L, Math.max(0.6 * px, 1.2));
    }
    // etched 50 x 50 grid lines (per spec drawings), only when legible
    var lay = holeLayout(L, W, sysKey);
    if (50 * s >= 5) {
      g.beginPath();
      var gx0 = ((lay.x0 - 25) % 50 + 50) % 50, gy0 = ((lay.y0 - 25) % 50 + 50) % 50, x;
      for (x = gx0; x <= L + 0.01; x += 50) { g.moveTo(x, 0); g.lineTo(x, W); }
      for (x = gy0; x <= W + 0.01; x += 50) { g.moveTo(0, x); g.lineTo(L, x); }
      g.strokeStyle = 'rgba(20,22,26,' + clamp(0.1 + (50 * s - 5) * 0.012, 0.1, 0.24) + ')';
      g.lineWidth = 0.7 * px; g.stroke();
    }
    // holes: bore wall ring + dark core offset away from the light
    var r = sys.hole / 2, hp = r * s, pts = lay.pts, p1 = new Path2D(), p2 = hp >= 1.4 ? new Path2D() : null;
    var off = r * 0.2, r2 = r * 0.78;
    for (i = 0; i < pts.length; i += 2) {
      var hx = pts[i], hy = pts[i + 1];
      p1.moveTo(hx + r, hy); p1.arc(hx, hy, r, 0, TAU);
      if (p2) { p2.moveTo(hx + off + r2, hy + off); p2.arc(hx + off, hy + off, r2, 0, TAU); }
    }
    if (hp >= 2.2) { // lit chamfer lip on the far side of each bore
      g.save(); g.translate(-0.9 * px, -0.9 * px); g.fillStyle = 'rgba(210,216,224,0.35)'; g.fill(p1); g.restore();
    }
    g.fillStyle = '#2a2e33'; g.fill(p1);
    if (p2) { g.fillStyle = '#0a0b0d'; g.fill(p2); }
    // etched corner mark
    if (40 * s >= 9) {
      g.fillStyle = 'rgba(20,22,26,0.32)';
      g.font = '700 ' + (sysKey === '16D' ? 22 : 30) + 'px ' + HFONT;
      g.textBaseline = 'middle'; g.textAlign = 'center';
      var mx = sysKey === '16D' ? lay.x0 + 25 : lay.x0 + 50, my = sysKey === '16D' ? lay.y0 + 25 : lay.y0;
      g.fillText('MAC', mx, my);
    }
    g.restore();
    // plate edge: skirt top (light top-left, dark bottom-right)
    g.lineWidth = 1;
    g.strokeStyle = 'rgba(255,255,255,0.32)';
    g.beginPath(); g.moveTo(0.5, ph - 0.5); g.lineTo(0.5, 0.5); g.lineTo(pw - 0.5, 0.5); g.stroke();
    g.strokeStyle = 'rgba(0,0,0,0.55)';
    g.beginPath(); g.moveTo(pw - 0.5, 0.5); g.lineTo(pw - 0.5, ph - 0.5); g.lineTo(0.5, ph - 0.5); g.stroke();
    var sk = Math.max(1, 8 * s);
    g.strokeStyle = 'rgba(255,255,255,0.07)'; g.lineWidth = 1;
    g.strokeRect(sk, sk, pw - 2 * sk, ph - 2 * sk);
    return { c: c, pw: pw, ph: ph };
  }

  /* ---------- Figure (top-down person, facing the table), in mm, facing -y ---------- */
  function personPath() {
    var p = new Path2D();
    // shoulders / upper arms as one rounded capsule, 500 mm wide x 230 mm deep
    p.moveTo(-135, -115); p.lineTo(135, -115);
    p.arc(135, 0, 115, -Math.PI / 2, Math.PI / 2);
    p.lineTo(-135, 115);
    p.arc(-135, 0, 115, Math.PI / 2, Math.PI * 1.5);
    p.closePath();
    return p;
  }
  var PERSON = null, HEAD = null, HANDS = null;
  function ensurePerson() {
    if (PERSON) return;
    PERSON = personPath();
    HEAD = new Path2D(); HEAD.ellipse(0, -22, 80, 102, 0, 0, TAU);
    HANDS = new Path2D();
    HANDS.ellipse(-190, -150, 42, 56, 0.25, 0, TAU);
    HANDS.ellipse(190, -150, 42, 56, -0.25, 0, TAU);
  }

  /* ---------- Instance ---------- */
  function Instance(root) {
    this.root = root;
    this.mode = root.getAttribute('data-mode') || 'scroll';
    this.track = root.querySelector('.mts__track');
    this.stage = root.querySelector('.mts__stage');
    this.view = root.querySelector('.mts__view');
    this.canvas = this.view.querySelector('canvas');
    this.ctx = this.canvas.getContext('2d');
    this.el = {};
    var self = this;
    ['l', 'w', 'series', 'holes', 'sys', 'grid', 'area', 'note', 'progress'].forEach(function (k) { self.el[k] = root.querySelector('[data-' + k + ']'); });
    this.base = STORY.map(function (s) { return { l: s[0], w: s[1] }; });
    this.story = this.base.slice();
    this.mine = null;
    this.el.mine = root.querySelector('[data-mine]'); this.el.eyebrow = root.querySelector('[data-eyebrow]');
    this.eyebrowText = this.el.eyebrow ? this.el.eyebrow.textContent : '';
    this.maxL = 3000; this.maxW = 1500;
    this.sys = '16D';
    this.cache = {}; this.gen = 0; this.queue = [];
    this.cur = { a: { l: this.story[0].l, w: this.story[0].w, sys: '16D' }, b: null, t: 0 };
    this.tween = null; this.infoKey = ''; this.idx = 0; this.raf = 0; this.dirty = true;
    this.active = true; this.lastW = 0; this.lastH = 0; this.safeB = 0;
    this.buildRail();
    this.bindSys();
    this.ready = false;
    this.observe();
  }
  var P = Instance.prototype;

  P.buildRail = function () {
    var rail = this.root.querySelector('.mts__rail'), self = this;
    if (!rail) return;
    rail.innerHTML = '';
    this.railBtns = this.story.map(function (s, i) {
      var li = D.createElement('li'), b = D.createElement('button');
      b.type = 'button'; b.innerHTML = '<span>' + s.l + '</span><i>\u00d7' + s.w + '</i>';
      b.setAttribute('aria-label', (s.mine ? 'Your table, ' : '') + s.l + ' by ' + s.w + ' millimetres');
      if (s.mine) b.className = 'is-mine';
      b.addEventListener('click', function () { self.goTo(i); });
      li.appendChild(b); rail.appendChild(li); return b;
    });
  };
  P.bindSys = function () {
    var self = this;
    this.sysBtns = Array.prototype.slice.call(this.root.querySelectorAll('[data-sys-btn]'));
    this.sysBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        if (b.disabled) return;
        self.sys = b.getAttribute('data-sys-btn');
        self.prime();
        var st = self.displayTarget();
        self.animateTo(st.l, st.w, self.effectiveSys(st.l, st.w), !RM);
      });
    });
  };
  P.effectiveSys = function (l, w) {
    if (this.sys === '28D') {
      var c = findCat(l, w);
      if (!c || !c[3].length) return '16D';
    }
    return this.sys;
  };
  P.displayTarget = function () { var c = this.cur; return (c.b && c.t >= 0.5) ? c.b : c.a; };

  /* layout: fit the largest size to the view at one constant scale */
  P.layout = function (force, bw, bh) {
    if (bw == null) { var r = this.view.getBoundingClientRect(); bw = r.width; bh = r.height; }
    var cw = Math.max(200, Math.round(bw)), ch = Math.max(200, Math.round(bh));
    // the stage uses svh units, so the mobile URL bar no longer resizes it; only skip sub-pixel noise
    if (!force && cw === this.lastW && Math.abs(ch - this.lastH) < 3) return false;
    this.lastW = cw; this.lastH = ch;
    var dpr = Math.min(W0.devicePixelRatio || 1, 2);
    this.dpr = dpr; this.cw = cw; this.ch = ch;
    this.canvas.width = Math.round(cw * dpr); this.canvas.height = Math.round(ch * dpr);
    this.canvas.style.width = cw + 'px'; this.canvas.style.height = ch + 'px';
    var portrait = cw < ch * 0.95, L = this.maxL, Wd = this.maxW, s;
    var GAP = 70, BODY = 240, FIG = GAP + BODY + 40; // mm reserved for the figure zone
    var dimPad = cw < 520 ? 30 : 42;
    if (!portrait) {
      s = Math.min((cw - dimPad * 2) / L, (ch - dimPad - 34) / (Wd + FIG));
      var used = dimPad + (Wd + FIG) * s;
      var top = dimPad + Math.max(0, (ch - 34 - used) / 2);
      this.geo = { portrait: false, s: s, cx: cw / 2 + dimPad * 0.25, base: top + Wd * s };
    } else {
      s = Math.min((cw - dimPad - 12) / (Wd + FIG), (ch - dimPad - 14) / L);
      var usedW = dimPad + (Wd + FIG) * s;
      var left = dimPad + Math.max(0, (cw - 8 - usedW) / 2);
      this.geo = { portrait: true, s: s, cy: dimPad + (ch - dimPad - 14) / 2, base: left + Wd * s };
    }
    this.gen++; this.cache = {}; this.queue = [];
    this.dirty = true;
    // warm up bitmaps in idle time, current first then neighbours then the rest
    this.prime();
    return true;
  };
  P.key = function (l, w, sys) { return l + 'x' + w + sys + (this.geo.portrait ? 'p' : 'l'); };
  P.bitmap = function (l, w, sys) {
    var k = this.key(l, w, sys), b = this.cache[k];
    if (!b) {
      var t0 = performance.now();
      b = this.cache[k] = renderTable(l, w, sys, this.geo.s, this.geo.portrait, this.dpr);
      this.lastRaster = performance.now() - t0;
    }
    return b;
  };
  P.prime = function () {
    var self = this, gen = this.gen, list = [], i0 = this.idx;
    var order = this.story.map(function (s, i) { return i; }).sort(function (a, b) { return Math.abs(a - i0) - Math.abs(b - i0); });
    order.forEach(function (i) { list.push([self.story[i].l, self.story[i].w, self.effectiveSys(self.story[i].l, self.story[i].w)]); });
    function step(dl) {
      if (gen !== self.gen) return;
      while (list.length) {
        var it = list.shift();
        if (self.cache[self.key(it[0], it[1], it[2])]) continue;
        self.bitmap(it[0], it[1], it[2]);
        break; // one raster per idle slot keeps every task short
      }
      if (list.length) idle(step);
    }
    idle(step);
  };

  P.plateRect = function (l, w) {
    var g = this.geo, s = g.s;
    if (!g.portrait) return { x: g.cx - l * s / 2, y: g.base - w * s, w: l * s, h: w * s };
    return { x: g.base - w * s, y: g.cy - l * s / 2, w: w * s, h: l * s };
  };

  /* ---------- draw one frame ---------- */
  P.render = function () {
    this.raf = 0;
    if (!this.dirty || !this.ready) return;
    if (!this.warm) { // first frame: raster the first bitmap in an idle slot, not inside this frame
      var me = this;
      if (!this.warming) {
        this.warming = true;
        idle(function () { var s = me.displayTarget(); me.bitmap(s.l, s.w, s.sys); getShadow(me.dpr); me.warm = true; me.dirty = true; me.kick(); });
      }
      return;
    }
    this.dirty = false;
    var ctx = this.ctx, g = this.geo, s = g.s, dpr = this.dpr, c = this.cur;
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    ctx.clearRect(0, 0, this.cw, this.ch);
    var A = c.a, B = c.b, t = B ? c.t : 0;
    var l = B ? lerp(A.l, B.l, t) : A.l, w = B ? lerp(A.w, B.w, t) : A.w;
    var R = this.plateRect(l, w);
    this.drawGhosts();
    // table: crossfade the two bitmaps, both mapped onto the interpolated plate rect
    drawShadow(this.ctx, R.x + 10, R.y + 20, R.w, R.h, dpr, 0.7);   // soft key shadow
    drawShadow(this.ctx, R.x + 2, R.y + 4, R.w, R.h, dpr, 0.35);    // tighter contact shadow
    // Both bitmaps are drawn at native (true) scale, anchored like their own plate and clipped to
    // the interpolated outline R. Hole grids share the anchor, so they line up and the plate
    // appears to extend or retract rather than stretch. The larger plate is the opaque base.
    if (!B || t <= 0) this.blit(A, R, 1);
    else {
      var aBig = A.l * A.w >= B.l * B.w;
      if (aBig) { this.blit(A, R, 1); this.blit(B, R, t); }
      else { this.blit(B, R, 1); this.blit(A, R, 1 - t); }
    }
    this.drawMine(l, w);
    this.drawFigure();
    this.drawScaleBar();
    var snap = t >= 0.5 && B ? B : A;
    this.drawDims(R, snap, B ? Math.abs(t - 0.5) * 2 : 1);
    this.state = { l: snap.l, w: snap.w, sys: snap.sys, rect: R, scale: s, portrait: g.portrait, holes: holeLayout(snap.l, snap.w, snap.sys).count, t: t };
    this.updateInfo(snap);
  };
  P.blit = function (S, R, alpha) {
    if (alpha <= 0.002) return;
    var b = this.bitmap(S.l, S.w, S.sys), ctx = this.ctx, own = this.plateRect(S.l, S.w);
    var x0 = Math.max(R.x, own.x), y0 = Math.max(R.y, own.y), x1 = Math.min(R.x + R.w, own.x + own.w), y1 = Math.min(R.y + R.h, own.y + own.h);
    if (x1 - x0 < 0.5 || y1 - y0 < 0.5) return;
    var k = b.c.width / own.w; // bitmap px per css px
    ctx.globalAlpha = alpha;
    ctx.drawImage(b.c, (x0 - own.x) * k, (y0 - own.y) * k, (x1 - x0) * k, (y1 - y0) * k, x0, y0, x1 - x0, y1 - y0);
    ctx.globalAlpha = 1;
  };
  P.drawGhosts = function () {
    var ctx = this.ctx;
    ctx.save();
    ctx.setLineDash([3, 5]); ctx.lineWidth = 1; ctx.strokeStyle = 'rgba(195,201,209,0.16)';
    for (var i = 0; i < this.story.length; i++) {
      var R = this.plateRect(this.story[i].l, this.story[i].w);
      ctx.strokeRect(Math.round(R.x) + 0.5, Math.round(R.y) + 0.5, Math.round(R.w) - 1, Math.round(R.h) - 1);
    }
    ctx.restore();
  };
  P.drawMine = function (l, w) { // the customer's configured size, outlined over whatever size is shown
    var m = this.mine;
    if (!m || (Math.abs(m.l - l) < 1 && Math.abs(m.w - w) < 1)) return;
    var R = this.plateRect(m.l, m.w), ctx = this.ctx, small = this.cw < 520;
    ctx.save();
    ctx.setLineDash([7, 5]); ctx.lineWidth = 1.6; ctx.strokeStyle = 'rgba(255,59,65,0.95)';
    ctx.strokeRect(Math.round(R.x) + 0.5, Math.round(R.y) + 0.5, Math.round(R.w) - 1, Math.round(R.h) - 1);
    ctx.setLineDash([]);
    ctx.font = '700 ' + (small ? 9 : 11) + 'px ' + MONO; ctx.textBaseline = 'top'; ctx.textAlign = 'right';
    var txt = 'YOUR TABLE', tw = ctx.measureText(txt).width + 10, th = small ? 14 : 17, x = Math.round(R.x + R.w) - 1, y = Math.round(R.y) + 1;
    ctx.fillStyle = '#e21b23'; ctx.fillRect(x - tw, y, tw, th);
    ctx.fillStyle = '#fff'; ctx.fillText(txt, x - 5, y + (small ? 2.5 : 3));
    ctx.restore();
  };
  P.drawFigure = function () {
    ensurePerson();
    var ctx = this.ctx, g = this.geo, s = g.s, off = (70 + 115 + 20) * s;
    ctx.save();
    if (!g.portrait) { ctx.translate(g.cx, g.base + off); }
    else { ctx.translate(g.base + off, g.cy); ctx.rotate(-Math.PI / 2); }
    ctx.scale(s, s);
    ctx.fillStyle = '#2d3239'; ctx.fill(PERSON);
    ctx.lineWidth = 1.2 / s; ctx.strokeStyle = 'rgba(195,201,209,0.35)'; ctx.stroke(PERSON);
    var hg = ctx.createRadialGradient(-20, -50, 10, 0, -22, 110);
    hg.addColorStop(0, '#5a616b'); hg.addColorStop(1, '#343a42');
    ctx.fillStyle = hg; ctx.fill(HEAD);
    ctx.stroke(HEAD);
    // 500 mm shoulder dimension
    ctx.strokeStyle = 'rgba(226,27,35,0.9)'; ctx.lineWidth = 1.2 / s;
    ctx.beginPath(); ctx.moveTo(-250, 150); ctx.lineTo(250, 150);
    ctx.moveTo(-250, 128); ctx.lineTo(-250, 172); ctx.moveTo(250, 128); ctx.lineTo(250, 172); ctx.stroke();
    ctx.restore();
    // label (kept upright)
    ctx.save();
    ctx.fillStyle = 'rgba(195,201,209,0.85)'; ctx.font = '600 ' + (this.cw < 520 ? 9 : 11) + 'px ' + MONO;
    ctx.textAlign = 'center'; ctx.textBaseline = 'top';
    if (!g.portrait) ctx.fillText('500 mm', g.cx, g.base + off + 162 * s + 3);
    else { ctx.translate(g.base + off + 150 * s + 4, g.cy); ctx.rotate(-Math.PI / 2); ctx.textBaseline = 'top'; ctx.fillText('500 mm', 0, 0); }
    ctx.restore();
  };
  P.drawScaleBar = function () {
    var ctx = this.ctx, g = this.geo, s = g.s, len = 1000 * s, seg = len / 5, x, y, i;
    ctx.save();
    ctx.font = '600 ' + (this.cw < 520 ? 9 : 11) + 'px ' + MONO; ctx.fillStyle = 'rgba(195,201,209,0.85)';
    if (!g.portrait) {
      x = 14; y = this.ch - 20;
      for (i = 0; i < 5; i++) { ctx.fillStyle = i & 1 ? '#c3c9d1' : '#e21b23'; ctx.fillRect(x + i * seg, y, seg, 5); }
      ctx.strokeStyle = 'rgba(195,201,209,0.6)'; ctx.lineWidth = 1; ctx.strokeRect(x + 0.5, y + 0.5, len - 1, 4);
      ctx.fillStyle = 'rgba(195,201,209,0.85)'; ctx.textBaseline = 'bottom';
      ctx.textAlign = 'left'; ctx.fillText('0', x, y - 3);
      ctx.textAlign = 'right'; ctx.fillText('1 m', x + len, y - 3);
    } else {
      x = this.cw - 16; y = this.ch - 12 - len;
      for (i = 0; i < 5; i++) { ctx.fillStyle = i & 1 ? '#c3c9d1' : '#e21b23'; ctx.fillRect(x, y + i * seg, 5, seg); }
      ctx.strokeStyle = 'rgba(195,201,209,0.6)'; ctx.lineWidth = 1; ctx.strokeRect(x + 0.5, y + 0.5, 4, len - 1);
      ctx.fillStyle = 'rgba(195,201,209,0.85)';
      ctx.translate(x - 4, y + len / 2); ctx.rotate(-Math.PI / 2); ctx.textAlign = 'center'; ctx.textBaseline = 'bottom';
      ctx.fillText('1 m', 0, 0);
    }
    ctx.restore();
    this.scaleBarPx = len;
  };
  P.drawDims = function (R, S, labelAlpha) {
    var ctx = this.ctx, g = this.geo, small = this.cw < 520, off = small ? 14 : 20, tk = 5;
    var hVal = g.portrait ? S.w : S.l, vVal = g.portrait ? S.l : S.w;
    ctx.save();
    ctx.strokeStyle = 'rgba(226,27,35,0.95)'; ctx.lineWidth = 1;
    var yT = Math.round(R.y - off) + 0.5, xL = Math.round(R.x - off) + 0.5;
    ctx.beginPath();
    // horizontal (top)
    ctx.moveTo(R.x, yT); ctx.lineTo(R.x + R.w, yT);
    ctx.moveTo(R.x, yT - tk); ctx.lineTo(R.x, yT + off - 3);
    ctx.moveTo(R.x + R.w, yT - tk); ctx.lineTo(R.x + R.w, yT + off - 3);
    // vertical (left)
    ctx.moveTo(xL, R.y); ctx.lineTo(xL, R.y + R.h);
    ctx.moveTo(xL - tk, R.y); ctx.lineTo(xL + off - 3, R.y);
    ctx.moveTo(xL - tk, R.y + R.h); ctx.lineTo(xL + off - 3, R.y + R.h);
    ctx.stroke();
    // arrow heads
    function arrow(x, y, ang) { ctx.save(); ctx.translate(x, y); ctx.rotate(ang); ctx.beginPath(); ctx.moveTo(0, 0); ctx.lineTo(7, -3); ctx.lineTo(7, 3); ctx.closePath(); ctx.fill(); ctx.restore(); }
    ctx.fillStyle = '#e21b23';
    arrow(R.x, yT, 0); arrow(R.x + R.w, yT, Math.PI); arrow(xL, R.y, Math.PI / 2); arrow(xL, R.y + R.h, -Math.PI / 2);
    // labels on pills
    ctx.globalAlpha = 0.35 + 0.65 * labelAlpha;
    ctx.font = '700 ' + (small ? 11 : 13) + 'px ' + MONO; ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
    function pill(txt, x, y, rot) {
      ctx.save(); ctx.translate(x, y); if (rot) ctx.rotate(-Math.PI / 2);
      var tw = ctx.measureText(txt).width + 12, th = small ? 16 : 19;
      ctx.fillStyle = '#0b0c0e'; ctx.fillRect(-tw / 2, -th / 2, tw, th);
      ctx.strokeStyle = 'rgba(226,27,35,0.9)'; ctx.strokeRect(-tw / 2 + 0.5, -th / 2 + 0.5, tw - 1, th - 1);
      ctx.fillStyle = '#ffffff'; ctx.fillText(txt, 0, 0.5); ctx.restore();
    }
    pill(fmt(hVal) + ' mm', R.x + R.w / 2, yT, false);
    pill(fmt(vVal) + ' mm', xL, R.y + R.h / 2, true);
    ctx.restore();
  };

  /* ---------- DOM info (only touched when the shown size changes) ---------- */
  P.updateInfo = function (S) {
    var k = S.l + 'x' + S.w + S.sys;
    if (k === this.infoKey) return;
    this.infoKey = k;
    var e = this.el, lay = holeLayout(S.l, S.w, S.sys), cat = findCat(S.l, S.w), sys = SYSTEMS[S.sys];
    if (e.l) e.l.textContent = S.l;
    if (e.w) e.w.textContent = S.w;
    if (e.holes) e.holes.textContent = String(lay.count).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    if (e.sys) e.sys.textContent = sys.label;
    if (e.grid) e.grid.textContent = sys.grid;
    if (e.area) e.area.textContent = (S.l * S.w / 1e6).toFixed(2) + ' m\u00b2';
    var isMine = !!(this.mine && this.mine.l === S.l && this.mine.w === S.w);
    if (e.series) e.series.textContent = (isMine && this.mine.label && S.sys === this.mine.sys) ? this.mine.label : (cat ? seriesText(S.sys === '28D' ? cat[3] : cat[2]) : 'Custom size');
    if (e.eyebrow) e.eyebrow.textContent = isMine ? 'Your table \u00b7 true scale' : this.eyebrowText;
    this.root.classList.toggle('is-mine-shown', isMine);
    var has28 = !!(cat && cat[3].length);
    if (e.note) e.note.textContent = (this.sys === '28D' && !has28) ? '28D is offered on PRO 10 and ULTRA sizes \u2014 showing 16D.' : '';
    this.sysBtns.forEach(function (b) {
      var v = b.getAttribute('data-sys-btn');
      b.setAttribute('aria-pressed', v === S.sys ? 'true' : 'false');
    });
    var idx = -1;
    for (var i = 0; i < this.story.length; i++) if (this.story[i].l === S.l && this.story[i].w === S.w) idx = i;
    if (this.railBtns) this.railBtns.forEach(function (b, i) { b.classList.toggle('is-on', i === idx); b.classList.toggle('is-past', idx >= 0 && i < idx); });
    this.canvas.setAttribute('aria-label', 'Overhead view of a ' + S.l + ' by ' + S.w + ' millimetre MAC welding table top, ' + S.sys + ' holes, ' + lay.count + ' holes, drawn to scale beside a 1 metre scale bar and a person 500 millimetres across the shoulders.');
    this.root.dispatchEvent(new CustomEvent('mac:tablesize', { bubbles: true, detail: { l: S.l, w: S.w, system: S.sys, holes: lay.count, yours: isMine } }));
  };

  /* ---------- scroll driving ---------- */
  var HOLD = 0.42, END_HOLD = 0.7;
  P.units = function () { return (this.story.length - 1) + END_HOLD; };
  P.setMine = function (l, w, sys, label) {
    var same = this.mine && this.mine.l === l && this.mine.w === w;
    this.mine = l ? { l: l, w: w, sys: sys, label: label || '', mine: true } : null;
    if (!same) {
      // the customer's size goes first (unless it already is the first size); the standard range follows
      var b0 = this.base[0], dup = this.mine && b0.l === l && b0.w === w;
      this.story = (this.mine && !dup ? [this.mine] : []).concat(this.base);
      if (dup) this.story[0] = { l: b0.l, w: b0.w, mine: true };
      // Keep the track height fixed (CSS --mts-units default). Changing it here made everything below this
      // section (the configurator) jump by one step (46svh) whenever the picked size flipped to/from 520x520.
      // Scroll progress is normalised by trackRange, so the longer story still fits the same track.
      this.buildRail();
      this.infoKey = '';
    }
    if (this.el.mine) {
      this.el.mine.hidden = !this.mine;
      var b = this.el.mine.querySelector('b');
      if (b && this.mine) b.textContent = l + ' \u00d7 ' + w + ' mm \u00b7 ' + sys + (label ? ' \u00b7 ' + label : '');
    }
  };
  P.measure = function () {
    this.safeArea();
    if (this.mode !== 'scroll' || RM) return;
    var r = this.track.getBoundingClientRect();
    this.trackTop = r.top + W0.pageYOffset - (this.topOff || 0); // the stage pins at top: --mts-top
    this.trackRange = Math.max(1, this.track.offsetHeight - this.stage.offsetHeight);
  };
  P.fromScroll = function () {
    var p = clamp((W0.pageYOffset - this.trackTop) / this.trackRange, 0, 1);
    if (this.el.progress) this.el.progress.style.transform = 'scaleX(' + p.toFixed(4) + ')';
    var u = p * this.units(), n = this.story.length, k = Math.floor(u), f = u - k, S = this.story, sys;
    if (k >= n - 1) { k = n - 1; f = 0; }
    var t = f < HOLD ? 0 : easeIO((f - HOLD) / (1 - HOLD));
    var a = S[k], b = S[Math.min(k + 1, n - 1)];
    this.idx = t >= 0.5 ? k + 1 : k;
    this.cur = {
      a: { l: a.l, w: a.w, sys: this.effectiveSys(a.l, a.w) },
      b: t > 0 ? { l: b.l, w: b.w, sys: this.effectiveSys(b.l, b.w) } : null,
      t: t
    };
    this.dirty = true;
  };
  P.goTo = function (i) {
    var s = this.story[i];
    if (this.mode === 'scroll' && !RM) {
      var y = this.trackTop + ((i + (i === this.story.length - 1 ? 0.3 : HOLD * 0.5)) / this.units()) * this.trackRange;
      W0.scrollTo({ top: Math.round(y), behavior: 'smooth' });
    } else this.animateTo(s.l, s.w, this.effectiveSys(s.l, s.w), !RM);
  };
  P.animateTo = function (l, w, sys, animate) {
    if (l > this.maxL || w > this.maxW) { // keep one constant scale that still fits
      this.maxL = Math.max(this.maxL, Math.max(l, w)); this.maxW = Math.max(this.maxW, Math.min(l, w));
      this.layout(true);
    }
    var from = this.displayTarget(), self = this;
    if (from.l === l && from.w === w && from.sys === sys) { this.cur = { a: from, b: null, t: 0 }; this.dirty = true; this.kick(); return; }
    if (!animate) { this.cur = { a: { l: l, w: w, sys: sys }, b: null, t: 0 }; this.dirty = true; this.kick(); return; }
    this.bitmap(l, w, sys); // raster target up front (single small task)
    var t0 = performance.now(), dur = 620;
    this.tween = function (now) {
      var t = clamp((now - t0) / dur, 0, 1);
      self.cur = { a: from, b: { l: l, w: w, sys: sys }, t: easeIO(t) };
      if (t >= 1) { self.cur = { a: { l: l, w: w, sys: sys }, b: null, t: 0 }; self.tween = null; }
      self.dirty = true;
    };
    this.kick();
  };
  P.kick = function () {
    var self = this;
    if (this.raf) return;
    this.raf = requestAnimationFrame(function loop(now) {
      self.raf = 0;
      if (self.tween) self.tween(now);
      self.render();
      if (self.tween) self.raf = requestAnimationFrame(loop);
    });
  };
  P.observe = function () {
    var self = this;
    if ('ResizeObserver' in W0) {
      new ResizeObserver(function (en) {
        var cr = en[0].contentRect;
        self.onSize(cr.width, cr.height);
      }).observe(this.view);
    } else {
      requestAnimationFrame(function () { self.onSize(); });
      W0.addEventListener('resize', function () { self.onSize(); }, { passive: true });
    }
  };
  P.safeArea = function () {
    // theme bars fixed to the bottom of the screen on phones (mobile sticky bar, configurator price bar):
    // keep the rail and the scale bar clear of them. Runs inside ResizeObserver callbacks (layout is clean).
    var b = 0, ih = W0.innerHeight, sb = D.querySelector('.m-mobile-sticky-bar'), pb = D.querySelector('.mac-cfx-bar');
    if (sb && sb.offsetHeight && getComputedStyle(sb).display !== 'none') b = Math.max(b, ih - sb.getBoundingClientRect().top);
    if (pb && pb.offsetHeight && getComputedStyle(pb).display !== 'none') b = Math.max(b, (parseFloat(pb.style.bottom) || 10) + pb.offsetHeight);
    b = Math.round(clamp(b, 0, ih * 0.25));
    if (this.topOff == null) { // once: the space the theme header takes at load (it hides on scroll down)
      var hg = D.querySelector('.shopify-section-group-header-group') || D.querySelector('header');
      var hv = parseFloat(getComputedStyle(D.documentElement).getPropertyValue('--m-header-height')) || 0;
      var hh = hg ? hg.getBoundingClientRect().height : 0;
      this.topOff = RM || this.mode !== 'scroll' ? 0 : Math.round(clamp(Math.max(hh, hv), 0, ih * 0.2));
      this.root.style.setProperty('--mts-top', this.topOff + 'px');
      if (this.topOff) { this.safeB = b; this.root.style.setProperty('--mts-safe-b', b + 'px'); return true; }
    }
    if (b !== this.safeB) { this.safeB = b; this.root.style.setProperty('--mts-safe-b', b + 'px'); return true; }
    return false;
  };
  P.onSize = function (w, h) {
    // runs after the browser's own layout (ResizeObserver), so reads here are not forced reflows
    var first = !this.ready;
    if (first && this.safeArea()) { var vr = this.view.getBoundingClientRect(); w = vr.width; h = vr.height; } // padding changed once at start
    this.layout(first, w, h);
    this.measure();
    if (first) { this.ready = true; this.bind(); }
    if (this.mode === 'scroll' && !RM) this.fromScroll();
    this.dirty = true; this.kick();
  };
  P.bind = function () {
    var self = this, mt = 0;
    if (this.mode === 'scroll' && !RM) {
      if ('IntersectionObserver' in W0) {
        new IntersectionObserver(function (en) { self.active = en[0].isIntersecting; if (self.active) { self.fromScroll(); self.kick(); } }, { rootMargin: '200px 0px' }).observe(this.track);
      }
      W0.addEventListener('scroll', function () {
        if (!self.active || self.tween) return;
        self.fromScroll(); self.kick();
      }, { passive: true });
      // page height can change above us (fonts, images, configurator steps opening): re-measure
      W0.addEventListener('load', function () { self.measure(); });
      if ('ResizeObserver' in W0) {
        new ResizeObserver(function () { // callback runs after layout, so these reads are cheap
          self.measure(); if (self.active && !self.tween) { self.fromScroll(); self.kick(); }
        }).observe(D.body);
      }
      if (D.fonts && D.fonts.ready) D.fonts.ready.then(function () { clearTimeout(mt); mt = setTimeout(function () { self.measure(); self.fromScroll(); self.kick(); }, 50); });
    }
  };
  P.getState = function () { return this.state; };

  /* ---------- boot (lazy: starts when the section comes within ~1 screen) ---------- */
  var instances = [], pending = null;
  function start(el) {
    syncCatalog();
    var inst = new Instance(el);
    instances.push(inst);
    if (pending) { var p = pending; pending = null; apply(inst, p, false); }
    return inst;
  }
  function boot() {
    syncCatalog();
    Array.prototype.forEach.call(D.querySelectorAll('[data-mts]'), function (el) {
      if (!('IntersectionObserver' in W0)) { start(el); return; }
      var io = new IntersectionObserver(function (en) {
        if (!en[0].isIntersecting) return;
        io.disconnect(); idle(function () { start(el); });
      }, { rootMargin: '100% 0px' });
      io.observe(el);
    });
    wireSkip();
    wireConfigurator();
  }
  /* "Skip to the configurator" links: only when the configurator is further down the page.
   * User-initiated scroll only; focus moves to the configurator for keyboard users. */
  function cfgAfter(sec, wc) { return !!(sec.compareDocumentPosition(wc) & 4); } // 4 = DOCUMENT_POSITION_FOLLOWING
  function wireSkip() {
    var sec = D.querySelector('[data-mts]'), wc = D.querySelector('.wc[data-welding-configurator]');
    var links = D.querySelectorAll('[data-mts-skip]');
    if (!sec || !wc || !links.length || !cfgAfter(sec, wc)) return;
    var host = wc.closest('.shopify-section') || wc;
    Array.prototype.forEach.call(links, function (a) {
      if (host.id) a.setAttribute('href', '#' + host.id);
      a.textContent = a.textContent.replace(/\s*[\u2193\u2191]\s*$/, '') + ' \u2193';
      a.hidden = false;
      a.addEventListener('click', function (e) {
        e.preventDefault();
        var top = host.getBoundingClientRect().top + W0.pageYOffset;
        W0.scrollTo({ top: Math.max(0, Math.round(top)), behavior: RM ? 'auto' : 'smooth' });
        // an instant jump can make the theme header shrink (sticky state) and shift the page; settle once
        if (RM) setTimeout(function () { var d = host.getBoundingClientRect().top; if (Math.abs(d) > 2) W0.scrollBy(0, d); }, 150);
        var f = wc.querySelector('.wc__header h1, .wc__header h2, .wc__header') || wc;
        if (!f.hasAttribute('tabindex')) f.setAttribute('tabindex', '-1');
        try { f.focus({ preventScroll: true }); } catch (x) {}
      });
    });
  }
  function skipText(back) { // "Back to the configurator" once the customer has picked a size
    var sec = D.querySelector('[data-mts]'); if (!sec) return;
    var t = back ? sec.getAttribute('data-back-label') : null;
    Array.prototype.forEach.call(D.querySelectorAll('[data-mts-skip]'), function (a) {
      if (!a.getAttribute('data-skip-label')) a.setAttribute('data-skip-label', a.textContent.replace(/\s*[\u2193\u2191]\s*$/, ''));
      a.textContent = (t || a.getAttribute('data-skip-label')) + ' \u2193';
    });
  }
  function apply(inst, o, animate) {
    syncCatalog();
    if (o.clear) { inst.setMine(0); }
    else {
      if (o.system) inst.sys = o.system;
      if (o.yours !== false) inst.setMine(o.l, o.w, inst.effectiveSys(o.l, o.w), o.label);
    }
    var t = o.clear ? inst.story[0] : o;
    if (!inst.ready) { inst.cur = { a: { l: t.l, w: t.w, sys: inst.effectiveSys(t.l, t.w) }, b: null, t: 0 }; inst.idx = 0; return; }
    inst.idx = 0; inst.prime();
    // In the pinned story the customer's table is step 1, so arriving at the section shows it.
    // Only animate when the section is near the screen; otherwise just position it. Never scrolls
    // the page; the track height change is picked up by the body ResizeObserver (no forced layout here).
    inst.animateTo(t.l, t.w, inst.effectiveSys(t.l, t.w), animate && inst.active && !RM);
  }
  function byIndex(i) {
    var el = D.querySelectorAll('[data-mts]')[i];
    for (var k = 0; k < instances.length; k++) if (instances[k].root === el) return instances[k];
    return null;
  }
  W0.MacTableSize = {
    catalog: CATALOG, story: STORY, systems: SYSTEMS, instances: instances, holeLayout: holeLayout,
    // setSize(l, w, {system:'16D'|'28D', animate:true, label:'ULTRA 15', yours:true})
    setSize: function (l, w, opts) {
      opts = opts || {};
      var o = { l: Math.round(l), w: Math.round(w), system: opts.system, label: opts.label, yours: opts.yours };
      var inst = opts.instance != null ? byIndex(opts.instance) : instances[0];
      if (!inst) { pending = o; return; }
      apply(inst, o, opts.animate !== false);
    },
    clearSize: function () { var inst = instances[0]; if (!inst) { pending = null; return; } apply(inst, { clear: true }, true); },
    // scroll (user initiated only) so the section's first step, the customer's table, is in view
    reveal: function () {
      var el = D.querySelector('[data-mts]'); if (!el) return;
      var inst = byIndex(0), top;
      if (inst && inst.mode === 'scroll' && !RM) { inst.measure(); top = inst.trackTop; }
      else top = el.getBoundingClientRect().top + W0.pageYOffset;
      W0.scrollTo({ top: Math.max(0, Math.round(top)), behavior: RM ? 'auto' : 'smooth' });
    },
    getState: function (i) { var inst = byIndex(i || 0); return inst && inst.getState(); }
  };

  /* ---------- Table Configurator hook ----------
   * Reads the configurator's rendered DOM only (no edits to its JS, prices or data). The engine
   * re-renders the summary after every pick; a MutationObserver on the summary picks that up, and
   * the work runs in a later task so it never sits inside the configurator's click/price update.
   * The configurator pre-selects 16D / BASIC / 520 x 520 on load; that default is ignored until the
   * customer actually picks something. */
  function wireConfigurator() {
    var sec = D.querySelector('[data-mts][data-sync="true"]');
    var wc = D.querySelector('.wc[data-welding-configurator]');
    if (!sec || !wc || !('MutationObserver' in W0)) return;
    var sum = wc.querySelector('[data-role="summary"]');
    if (!sum) return;
    var touched = false, reset = false, last = '', timer = 0, link = null;
    var linkText = sec.getAttribute('data-link-label') || '';
    wc.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-action]');
      if (!b || b.disabled) return;
      var a = b.getAttribute('data-action');
      if (a === 'reset') { reset = true; touched = false; }
      else if (a === 'hole-system' || a === 'thickness' || a === 'product' || a === 'size') touched = true;
    }, true);
    function read() {
      timer = 0;
      if (reset) { reset = false; last = ''; W0.MacTableSize.clearSize(); if (link) link.hidden = true; skipText(false); return; }
      if (!touched) return;
      var hs = wc.querySelector('[data-action="hole-system"].is-selected');
      var sz = wc.querySelector('[data-action="size"].is-selected');
      var pr = wc.querySelector('[data-action="product"].is-selected');
      if (!sz) return;
      var m = String(sz.getAttribute('data-value') || '').match(/(\d+)\s*x\s*(\d+)/i);
      if (!m) return;
      var sys = hs && hs.getAttribute('data-value') === '28D' ? '28D' : '16D';
      var l = +m[1], w = +m[2], key = l + 'x' + w + sys;
      if (key === last) return;
      last = key;
      var label = '', d = W0.WELDING_CONFIGURATOR_DATA, pid = pr && pr.getAttribute('data-value');
      if (d && d.products && pid) for (var i = 0; i < d.products.length; i++) if (d.products[i].id === pid) label = String(d.products[i].name || d.products[i].title || '');
      W0.MacTableSize.setSize(l, w, { system: sys, label: label });
      showLink(l, w); skipText(true);
    }
    function showLink(l, w) { // "view it at true scale" button under the size chips (28 Sep: was a text link)
      if (!linkText) return;
      var wrap = wc.querySelector('[data-step="3"] .wc-size-wrap');
      if (!wrap) return;
      if (!link || !wrap.contains(link)) {
        link = D.createElement('p'); link.className = 'mts-cfg-link';
        link.innerHTML = '<a class="mts-cfg-btn" href="#' + sec.id + '">' +
          '<svg class="mts-cfg-btn__ico" viewBox="0 0 16 16" width="16" height="16" aria-hidden="true" focusable="false">' +
          '<path d="M8 13.5V3M3.5 7.5 8 3l4.5 4.5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="square"/></svg>' +
          '<span class="mts-cfg-btn__txt"></span></a>';
        link.firstChild.addEventListener('click', function (e) { e.preventDefault(); W0.MacTableSize.reveal(); });
        wrap.appendChild(link);
      }
      link.hidden = false;
      // arrow icon points to where the section is: up when it sits above the configurator
      var a = link.firstChild, t = a.lastChild, parts = linkText.split('[size]');
      a.classList.toggle('mts-cfg-btn--down', !cfgAfter(sec, wc));
      t.textContent = '';
      for (var i = 0; i < parts.length; i++) {
        if (i) { var s = D.createElement('span'); s.className = 'mts-cfg-btn__size'; s.textContent = l + ' \u00d7 ' + w + ' mm'; t.appendChild(s); }
        if (parts[i]) t.appendChild(D.createTextNode(parts[i]));
      }
    }
    new MutationObserver(function () { if (!timer) timer = setTimeout(read, 0); }).observe(sum, { childList: true });
  }

  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', boot); else boot();
})();
